
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"beneficiario"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cpf"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataNascimento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beneficiario"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cpf"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cpf"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataNascimento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataNascimento"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nome"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numeroDocumento"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataEmissaoDocumento"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orgaoEmissorDocumento"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ufDocumento"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sexo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cpf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dddTelefone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telefone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logradouro"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numeroLogradouro"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bairro"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cep"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nomeMae"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"acompanhante"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telefones"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ddd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telefone"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"municipio"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"processos"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tipoProcesso"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descricao"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tipoAtendimento"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descricao"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":649}};
    doc.loc.source = {"body":"query beneficiario(\n  $cpf: String!\n  $dataNascimento: String!\n) {\n  beneficiario(\n    cpf: $cpf\n    dataNascimento: $dataNascimento    \n  ) {\n    id\n    nome\n    numeroDocumento\n    dataEmissaoDocumento\n    orgaoEmissorDocumento\n    ufDocumento\n    sexo\n    dataNascimento\n    cpf\n    dddTelefone\n    telefone\n    email\n    logradouro\n    numeroLogradouro\n    bairro\n    cep\n    nomeMae\n    acompanhante\n    telefones{\n      id\n      ddd\n      telefone\n    }\n    municipio {\n      id\n    }\n    processos {\n      id\n      tipoProcesso {\n        id\n        descricao\n      }\n      tipoAtendimento {\n        id\n        descricao\n      }\n    }\n  }, \n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["beneficiario"] = oneQuery(doc, "beneficiario");
        
